<div class="background">
  <div class="price-container" [class.small]="small()">
    @if (strikethroughPrice()) {
      <s class="strikethrough-price">
        <ng-container [ngTemplateOutlet]="displayPrice"
                      [ngTemplateOutletContext]="{ price: strikethroughPrice() }"></ng-container>
      </s>
    }
    <span class="price">
      <ng-container [ngTemplateOutletContext]="{ price: price() }" [ngTemplateOutlet]="displayPrice"></ng-container>
    </span>
  </div>
</div>
<ng-template #displayPrice let-price="price">
  <ui-product-prices-formatter
    [price]="price"
    [showThousandthsPlace]="showThousandthsPlace()"
  ></ui-product-prices-formatter>
</ng-template>
